
export enum AddressStatus {
    New, Active, Inactive
}
